/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Highlight_Security_DescriptionInputs */



/**
* | output |
* | --- |
* | "SSO, audit logs, and regional data residency options meet the strictest compliance standards." |
*
* @param {Pricing_Highlight_Security_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_highlight_security_description = /** @type {((inputs?: Pricing_Highlight_Security_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Highlight_Security_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SSO, Prüfprotokolle und regionale Datenresidenz-Optionen erfüllen die strengsten Compliance-Anforderungen.")
	return /** @type {LocalizedString} */ ("SSO, audit logs, and regional data residency options meet the strictest compliance standards.")
});